<div class="content-dialog">
    <div class="dialog-header">
        <span>{{ data.isUploadFlow ? 'SOLICITUD DE PLANILLA' : 'SOLICITUD DE DOCUMENTO' }}</span>
        <button type="button" class="dialog-header__close" [mat-dialog-close]="undefined" aria-label="Cerrar">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="dialog-body">

        <div class="intro-banner">
            <span class="intro-banner__icon"><mat-icon>description</mat-icon></span>
            <div class="intro-banner__text">
                <div class="intro-banner__title">Búsqueda de <strong>documento</strong></div>
                <div class="intro-banner__subtitle">{{getSubtitle()}}</div>
            </div>
        </div>

        <ng-container *ngIf="data.isUploadFlow">
            <div class="section-label">
                <span class="section-label__icon"><mat-icon>business</mat-icon></span>
                <span>EMPRESA</span>
            </div>
            <div class="info-card" *ngFor="let empresa of empresaSelected">
                <img class="info-card__img" src="{{s3Bucket+getImg(empresa.Logo)}}" alt="">
                <div class="info-card__body">
                    <h3 class="info-card__title">{{empresa.Name}}</h3>
                    <div class="info-card__field">{{empresa.DocumentType}}: {{empresa.DocumentNumber}}</div>
                </div>
                <button type="button" class="info-card__action" (click)="setValueEmpresa()" aria-label="Cambiar empresa">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <app-select-search class="select-component" *ngIf="empresaSelected.length === 0 && puedeBuscarEmpresa() && cargandoEmpresas === false"
                            [_dataSource]="empresas" [textInput]="''" [placeholder]="'Seleccione para buscar la empresa'" [inputType]="'text'"
                            [dataShow]="'Name'" [dataValue]="'Id'" [otherFilter]="'DocumentNumber'" [siteCtrl]="controlEmpresa"
                            [isCard]="true"
                            [card]="{img: 'Logo', title: 'Name', itemKey: 'DocumentType', itemValue: 'DocumentNumber'}"
                            (onSelectionChange)="valueSelectedEmpresa($event)">
            </app-select-search>
            <div class="posgress" *ngIf="empresaSelected.length === 0 && puedeBuscarEmpresa() && cargandoEmpresas === true">
                <h4>CARGANDO EMPRESAS</h4>
                <mat-progress-bar mode="query" [value]="20"></mat-progress-bar>
            </div>
        </ng-container>

        <ng-container *ngIf="!data.isUploadFlow">
            <div class="section-label">
                <span class="section-label__icon"><mat-icon>description</mat-icon></span>
                <span>DOCUMENTO</span>
            </div>
            <app-select-search class="select-component" *ngIf="cargandoDocumentos === false"
                            [_dataSource]="documentos" [textInput]="''" [placeholder]="'Seleccione para buscar el Documento'" [inputType]="'text'"
                            [dataShow]="'Name'" [dataValue]="'Id'" [siteCtrl]="controlDocumento"
                            (onSelectionChange)="valueSelectedDocumento($event)">
            </app-select-search>
        </ng-container>

        <ng-container *ngIf="data.isUploadFlow">
            <div class="section-label">
                <span class="section-label__icon"><mat-icon>description</mat-icon></span>
                <span>DOCUMENTO</span>
            </div>
            <ngx-dropzone *ngIf="files.length === 0" (change)="onSelect($event)" class="dropzone" [multiple]="false" style="border: 2px dashed #ccc; border-radius: 8px; padding: 20px; text-align: center; cursor: pointer; min-height: 80px; margin-bottom: 20px; display: flex; align-items: center; justify-content: center;">
                <ngx-dropzone-label style="color: #999;">Clic aquí ó arrastra y suelta un archivo</ngx-dropzone-label>
            </ngx-dropzone>
            <div *ngFor="let file of files; let i = index" style="display: flex; align-items: center; justify-content: space-between; padding: 10px 15px; border: 1px solid #e0e0e0; border-radius: 8px; margin-bottom: 20px;">
                <div style="display: flex; align-items: center;">
                    <mat-icon style="color: #f44336; margin-right: 10px;">picture_as_pdf</mat-icon>
                    <span>{{file.name}}</span>
                </div>
                <mat-icon (click)="removeFile(i)" style="cursor: pointer; color: #888; background: #e8f5e9; color: #66c224; border-radius: 50%; padding: 2px;">close</mat-icon>
            </div>

            <div class="section-label">
                <span class="section-label__icon"><mat-icon>comment</mat-icon></span>
                <span>COMENTARIO</span>
            </div>
            <mat-form-field appearance="outline" style="width: 100%; margin-bottom: 20px;">
                <textarea matInput placeholder="Escriba una observación para la empresa" [(ngModel)]="comentario" rows="3" style="resize: none;"></textarea>
            </mat-form-field>
        </ng-container>
        <div class="posgress" *ngIf="cargandoDocumentos === true">
            <h4>CARGANDO DOCUMENTOS</h4>
            <mat-progress-bar mode="query" [value]="20"></mat-progress-bar>
        </div>

        <ng-container *ngIf="data.module === 'Personal'">
            <div class="section-label">
                <span class="section-label__icon"><mat-icon>person</mat-icon></span>
                <span>PERSONA</span>
            </div>
            <div class="info-card" *ngFor="let persona of personaSelected">
                <img class="info-card__img" src="{{s3Bucket+getImgPersonal(persona.Photo)}}" alt="" (error)="commonMetodService._getUrlErrorImg('personal', $event)">
                <div class="info-card__body">
                    <h3 class="info-card__title">{{(persona.Name | uppercase)}} {{(persona.LastName | uppercase)}}</h3>
                    <div class="info-card__field">{{persona.DocumentType}}: {{persona.DocumentNumber}}</div>
                </div>
                <button type="button" class="info-card__action" (click)="setValuePersona()" aria-label="Cambiar persona">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <div class="search-row" *ngIf="personaSelected.length === 0 && documentoSelected.length === 1">
                <div class="field-box search-field--type">
                    <span class="field-box__label">TIPO DE DOCUMENTO</span>
                    <div class="field-box__control">
                        <mat-icon class="field-box__icon">person_outline</mat-icon>
                        <mat-form-field>
                            <mat-select [(ngModel)]="documentType" (selectionChange)="changeType($event.value)">
                                <mat-option *ngFor="let data of companyDocumentType" [value]="data.Value">
                                    {{(data.Description === 'C.C.' ? 'Cedula': data.Description)}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="field-box search-field--number">
                    <span class="field-box__label">NÚMERO DE DOCUMENTO</span>
                    <div class="field-box__control">
                        <mat-icon class="field-box__icon">label</mat-icon>
                        <mat-form-field>
                            <input matInput type="text" [(ngModel)]="documentNumber" pattern="/^-?\d+\.?\d*$/" maxlength="{{maxCaracter}}">
                        </mat-form-field>
                        <button type="button" class="field-box__clear" aria-label="Limpiar" (click)="setValuePersona()">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>
                <button mat-mini-fab class="search-row__btn" matTooltip="buscar" [disabled]="buscandoPersona" (click)="getPersonalDocument()">
                    <mat-icon>search</mat-icon>
                </button>
            </div>
        </ng-container>

        <ng-container *ngIf="!data.isUploadFlow && mostrarEmpresa()">
            <div class="section-label">
                <span class="section-label__icon"><mat-icon>business</mat-icon></span>
                <span>EMPRESA</span>
            </div>
            <div class="info-card" *ngFor="let empresa of empresaSelected">
                <img class="info-card__img" src="{{s3Bucket+getImg(empresa.Logo)}}" alt="">
                <div class="info-card__body">
                    <h3 class="info-card__title">{{empresa.Name}}</h3>
                    <div class="info-card__field">{{empresa.DocumentType}}: {{empresa.DocumentNumber}}</div>
                </div>
                <button type="button" class="info-card__action" (click)="setValueEmpresa()" aria-label="Cambiar empresa">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <app-select-search class="select-component" *ngIf="empresaSelected.length === 0 && puedeBuscarEmpresa() && cargandoEmpresas === false"
                            [_dataSource]="empresas" [textInput]="''" [placeholder]="'Seleccione para buscar la empresa'" [inputType]="'text'"
                            [dataShow]="'Name'" [dataValue]="'Id'" [otherFilter]="'DocumentNumber'" [siteCtrl]="controlEmpresa"
                            [isCard]="true"
                            [card]="{img: 'Logo', title: 'Name', itemKey: 'DocumentType', itemValue: 'DocumentNumber'}"
                            (onSelectionChange)="valueSelectedEmpresa($event)">
            </app-select-search>
            <div class="posgress" *ngIf="empresaSelected.length === 0 && puedeBuscarEmpresa() && cargandoEmpresas === true">
                <h4>CARGANDO EMPRESAS</h4>
                <mat-progress-bar mode="query" [value]="20"></mat-progress-bar>
            </div>
        </ng-container>



        <div class="actions-dialog">
            <button mat-stroked-button class="btn-cancelar" style="border: 1px solid #66c224; color: #66c224; border-radius: 20px; padding: 0 20px;" [mat-dialog-close]="undefined">CANCELAR</button>
            <button mat-flat-button color="primary" [disabled]="!getDisabled()"
                    (click)="iniciar()"
                    style="background-color: #66c224; color: white; border-radius: 20px; padding: 0 20px;"
                    class="btn-generar">{{ data.isUploadFlow ? 'SOLICITAR REVISION' : 'INICIAR' }}
            </button>
        </div>
    </div>
</div>
